module.exports = __webpack_public_path__ + "media/roomBgm.6c294114.mp3";